import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AttentionMessage } from '@eika/attention-message';
import { Link, LinkType } from '@eika/link';

import { Header } from '../../components/header/header';
import { RadioButtons } from '../../components/radio-buttons/radio-buttons';
import SporreskjemaButton from '../../components/sporreskjema-button/sporreskjema-button';
import { StepNavigation } from '../../components/step-navigation/step-navigation';
import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useBankregnr } from '../../config';
import { toOptions } from '../../sporsmalsflyt/radio/radio';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { SideType } from '../../utils/piwik-utils';
import { getEttersendingUrl } from '../deep-link-handler';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.LandbrukProduksjonsdyrStorfe,
        tekst: 'Storfe',
        undertekst: 'Melkeku, ammeku, okse, kvige og kalv',
    },
    {
        id: KategoriSvarId.LandbrukProduksjonsdyrHusdyrIndividuell,
        tekst: 'Avlsokse',
        undertekst: 'Individuell forsikring',
    },
    {
        id: KategoriSvarId.LandbrukProduksjonsdyrSauGeit,
        tekst: 'Sau og geit',
    },
    {
        id: KategoriSvarId.LandbrukProduksjonsdyrGris,
        tekst: 'Gris',
    },
    {
        id: KategoriSvarId.LandbrukProduksjonsdyrFjorfe,
        tekst: 'Fjørfe',
    },
];

export const Produksjonsdyr = () => {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
    const bankregnr = useBankregnr();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.LandbrukProduksjonsdyrStorfe) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukProduksjonsdyrStorfe));
        } else if (svarId === KategoriSvarId.LandbrukProduksjonsdyrSauGeit) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukProduksjonsdyr));
        } else if (svarId === KategoriSvarId.LandbrukProduksjonsdyrGris) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukProduksjonsdyr));
        } else if (svarId === KategoriSvarId.LandbrukProduksjonsdyrFjorfe) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukProduksjonsdyr));
        } else if (svarId === KategoriSvarId.LandbrukProduksjonsdyrHusdyrIndividuell) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.LandbrukProduksjonsdyrIndividuellOkse));
        }
    };

    const goback = () => navigate(-1);

    return (
        <>
            <form className="meld-skade-form">
                <Header svgCardType={SvgCardType.DyrHone} title="Produksjonsdyr" subtitle="Skademelding" />
                <div className="container__standard-width ettersending-card">
                    <AttentionMessage
                        id="attention-ettersending"
                        text={
                            <p>
                                Har du hatt tap av samme type dyr i samme forsikringsår som du allerede har meldt inn?
                                Da kan du enkelt oppdatere saken din her - selv om saken står som avsluttet. Det sparer
                                både deg og oss for tid!
                            </p>
                        }
                        type="info"
                        clickableItem={
                            <Link href={getEttersendingUrl()} linkType={LinkType.BUTTON_STANDARD_NEGATIVE}>
                                Oppdater saken din
                            </Link>
                        }
                    />
                </div>
                <RadioButtons
                    name=""
                    label="Hva gjelder det?"
                    options={toOptions(alternativer)}
                    selectedOption={selectedOption}
                    onChange={setSelectedOption}
                    focusOnMount
                />
                <StepNavigation
                    bankregnr={bankregnr}
                    next={{
                        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            e.preventDefault();
                            onNext(selectedOption);
                        },
                        disabled: !selectedOption,
                    }}
                    prev={{
                        onClick: goback,
                    }}
                    sideDetail={{ type: SideType.Kategoriside, kategoriId: 'produksjonsdyr' }}
                />
            </form>
            <SporreskjemaButton />
        </>
    );
};
